export default __webpack_public_path__ + "static/media/closet5-after2-1440w.180c3338.png";